import { z } from 'zod';
/**
 * Country code — ISO 3166-1 alpha-2 uppercase.
 *
 * SCRUM-25 phase A.1 — backs the `identity.users.country` column. We
 * validate the SHAPE only (`^[A-Z]{2}$`), not membership in the live ISO
 * registry. The registry mutates (UK / GB conflation, deprecations like
 * AN, additions like ZZ for "unknown") and an authoritative codelist is
 * costly to maintain. Semantic validation against a curated codelist
 * lives outside this VO; consumers that need a closed set MUST layer
 * their own enum on top.
 */
export const COUNTRY_CODE_PATTERN = /^[A-Z]{2}$/u;
export const countryCodeSchema = z
    .string()
    .regex(COUNTRY_CODE_PATTERN, 'Must be ISO 3166-1 alpha-2 uppercase (e.g. "US", "GB")')
    .brand();
//# sourceMappingURL=country-code.js.map